module.exports = __webpack_public_path__ + "components/alert-table/static/icon-box-9cc0f311d00771d43f0a6ae57a4edc3f.svg";